
export const formatCurrency = (amount: number, options: { 
  showCents?: boolean 
} = {}): string => {
  const { showCents = false } = options;

  if (amount >= 1_000_000_000) {
    return `$${(amount / 1_000_000_000).toFixed(1)}B`;
  }
  
  if (amount >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(1)}M`;
  } 
  
  if (amount >= 1_000) {
    return `$${(amount / 1_000).toFixed(0)}K`;
  }

  return `$${showCents ? amount.toFixed(2) : Math.round(amount)}`;
};

// Short version as an alias for consistency
export const formatCurrencyShort = formatCurrency;
